import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";
import {
    WorkloadDisplay,
    WorkloadReportTypeView,
    WorkloadSummaryBy
} from "../../../../../../views/reports/resource/resource-report/model/const";


export default class ReportResourceAllocation_Settings {

    // View settings
    public display      : WorkloadDisplay
    public summaryBy    : WorkloadSummaryBy
    public typeView     : WorkloadReportTypeView
    public daterange    : DateRange
    public users        : ID[]
    public showTotal    : boolean
    public colorCoding  : boolean

    constructor(data: any) {
        this.display     = _.get(data, "display", WorkloadDisplay.HOUR)
        this.summaryBy   = _.get(data, "summaryBy", WorkloadSummaryBy.WORK_HOURS)
        this.typeView    = _.get(data, "typeView", WorkloadReportTypeView.DAILY)
        this.daterange   = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.users       = _.get(data, "users", [])
        this.showTotal   = _.get(data, "showTotal", true)
        this.colorCoding = _.get(data, "colorCoding", false)
    }

    get reportTitle() {
        let title = ""

        title += formatDaterange(this.daterange)

        return title
    }

    toJSON(): JSONObject {
        const result : JSONObject =  {
            display     : this.display,
            users       : this.users,
            summaryBy   : this.summaryBy,
            typeView    : this.typeView,
            showTotal   : this.showTotal,
            colorCoding : this.colorCoding
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
